/**
 * The known Product Features GUIDs (lowercase)
 */
export enum ProductFeatures {
    MLS = '3d0e9777-92a6-4048-87b1-d42d3b2b5379',
    SmartData = 'd3d551b6-dd4e-4a66-afd2-5af071975954',
    Chat = 'ba8f50fe-6386-4137-bfc9-704dedf068e9'
}
